  // Popup
  (function(){
    const popup = document.getElementById('popup');
    const close = document.getElementById('popupClose');
    if (!popup || !close) return; // legacy popup markup not on page — bail so the rest of this file still runs
    document.querySelectorAll('.hotspot').forEach(h => {
      h.addEventListener('click', e => {
        e.preventDefault();
        document.getElementById('popupName').textContent  = h.dataset.name || '';
        document.getElementById('popupSub').textContent   = h.dataset.sub || '';
        document.getElementById('popupPrice').textContent = h.dataset.price || '';
        document.getElementById('popupImg').src           = h.dataset.img || '';
        document.getElementById('popupCta').href          = h.dataset.link || '#';
        popup.classList.add('open');
      });
    });
    close.addEventListener('click', () => popup.classList.remove('open'));
    popup.addEventListener('click', e => {
      if (e.target === popup) popup.classList.remove('open');
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') popup.classList.remove('open');
    });
  })();

  // Mobile hamburger drawer (top-left dropdown)
  (function(){
    const hb = document.getElementById('hb');
    const drawer = document.getElementById('drawer');
    if (!hb || !drawer) return;
    function close(){
      drawer.classList.remove('open');
      hb.classList.remove('open');
      document.body.classList.remove('drawer-open');
    }
    function toggle(e){
      e && e.stopPropagation();
      const opened = drawer.classList.toggle('open');
      hb.classList.toggle('open', opened);
      document.body.classList.toggle('drawer-open', opened);
    }
    hb.addEventListener('click', toggle);
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
    drawer.addEventListener('click', e => e.stopPropagation());
    document.addEventListener('click', () => {
      if (drawer.classList.contains('open')) close();
    });
  })();

  // Category hover reveal (PC) + tap-to-preview, tap-again-to-navigate (mobile)
  (function(){
    const items = document.querySelectorAll('#catsMenu li');
    const imgs  = document.querySelectorAll('#catsStage img');
    const isTouch = window.matchMedia('(hover: none)').matches;
    items.forEach((li, idx) => {
      const link = li.querySelector('a');
      // Hover to switch (mouse / pen — mouseenter does not fire on touch taps)
      li.addEventListener('mouseenter', () => {
        items.forEach(x => x.classList.remove('active'));
        imgs.forEach(x => x.classList.remove('active'));
        li.classList.add('active');
        if (imgs[idx]) imgs[idx].classList.add('active');
      });
      // Touch: 1st tap = preview, 2nd tap = navigate
      if (link) {
        link.addEventListener('click', (e) => {
          if (!isTouch) return;
          if (!li.classList.contains('active')) {
            e.preventDefault();
            items.forEach(x => x.classList.remove('active'));
            imgs.forEach(x => x.classList.remove('active'));
            li.classList.add('active');
            if (imgs[idx]) imgs[idx].classList.add('active');
          }
        });
      }
    });
  })();

  // Hero slideshow
  (function(){
    const slides = document.querySelectorAll('.hero__slide');
    const captions = document.querySelectorAll('.hero__caption');
    const dots = document.querySelectorAll('.hero__dots button');
    if (slides.length < 2) return;
    let i = 0, timer;
    function go(n){
      slides[i].classList.remove('active');
      if (captions[i]) captions[i].classList.remove('active');
      if (dots[i]) dots[i].classList.remove('active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('active');
      if (captions[i]) captions[i].classList.add('active');
      if (dots[i]) dots[i].classList.add('active');
    }
    function start(){ timer = setInterval(() => go(i + 1), 5000); }
    dots.forEach(d => d.addEventListener('click', () => {
      clearInterval(timer);
      go(parseInt(d.dataset.i));
      start();
    }));
    start();

    // 「戻る」でトップに帰ってきたとき、スライドショーが途中状態から
    // 再開してフェードが重なって見えるのを防ぐ。フェードなしで即座に
    // 1枚目へリセットし、ローテーションを最初からやり直す。
    window.addEventListener('pageshow', () => {
      clearInterval(timer);
      slides.forEach(s => { s.style.transition = 'none'; s.classList.remove('active'); });
      captions.forEach(c => c.classList.remove('active'));
      dots.forEach(d => d.classList.remove('active'));
      i = 0;
      slides[0].classList.add('active');
      if (captions[0]) captions[0].classList.add('active');
      if (dots[0]) dots[0].classList.add('active');
      void slides[0].offsetWidth;
      slides.forEach(s => { s.style.transition = ''; });
      start();
    });

    // 横スワイプ / ドラッグで切替（スマホ・PC共通。縦スクロールは妨げない）
    const hero = document.querySelector('.hero');
    if (hero) {
      let sx = 0, sy = 0, tracking = false, swiped = false;
      hero.addEventListener('pointerdown', e => {
        sx = e.clientX; sy = e.clientY; tracking = true; swiped = false;
      });
      hero.addEventListener('pointerup', e => {
        if (!tracking) return;
        tracking = false;
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          clearInterval(timer);
          go(i + (dx < 0 ? 1 : -1));
          start();
        }
      });
      hero.addEventListener('pointercancel', () => { tracking = false; });
      // スワイプ後のclickでリンク遷移してしまうのを抑止
      hero.addEventListener('click', e => {
        if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
      }, true);
      // <a>スライドの画像ドラッグ（ゴースト）を無効化
      hero.addEventListener('dragstart', e => e.preventDefault());
    }
  })();

  const header = document.getElementById('header');
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.rv').forEach(el => io.observe(el));
